<template>
	<div :class="'dy-input ' + (_focus ? activeColor : '')">
		<i class="iconfont" :style="iconStyle" :class="iconClass" v-if="iconClass" @click="iconClick"></i>
		<input 
			spellcheck="false"
			v-model="_value" 
			autocomplete="off" 
			tabindex="0"
			:focus="focus" 
			:type="_type" 
			:maxlength="maxlength" 
			:placeholder="_placeholder" 
			:placeholder-class="placeholderClass" 
			:disabled="readonly"
			@confirm="pressEnter"
			@focus="onFocus"
			@blur="onBlur" />
		<!-- <div style="width: 20px;" v-if="clear&&_value.toString().length==0"></div> -->
		<dy-icon icon="icon-a-qingchucuowux16" tooltip="清空" @click="clearInput" v-if="clear && _value.toString().length>0"></dy-icon>
		<i v-if="percent" class="input-icon"  @click="focus = true">{{percent}}</i>
		
		<dy-icon :icon="_type=='password' ? 'icon-a-yanjingguanbix162' : 'icon-a-yanjingx163'" 
			:tooltip="_type=='password' ? '密码：隐藏' : '密码：显示'"
			@click="passwordShow" 
			v-if="type=='password'">
		</dy-icon>
		
		<span v-if="number && !nonumber">{{_value.toString().length + '/' + maxlength}}</span>
		
		<div class="list" :style="'width:' + (listWidth || '100%')" v-if="showList && list && list.length>0">
			<div class="listItem" v-for="item in list" @mousedown="selectText(item)">
				{{item}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:"dy-input",
		props:{
			focus:{
				type:Boolean,
				default:false,
			},
			nonumber:{
				type:Boolean,
				default:true,
			},
			iconClass:{
				type:String,
				default:'',
			},
			iconStyle:{
				type:String,
				default:'',
			},
			modelValue:{
				type:[String,Number],
				default:''
			},
			type:{
				type:String,
				default:'text',
			},
			number:{
				type:Boolean,
				default:true,
			},
			clear:{
				type:Boolean,
				default:true,
			},
			percent:{
				type:String,
				default:'',
			},
			maxlength:{
				type:[String,Number],
				default:255,				
			},
			placeholder:{
				type:String,
				default:'',
			},
			placeholderClass:{
				type:String,
				default:'',
			},
			readonly:{
				type:[String, Boolean],
				default:false,
			},
			activeColor:{
				type:String,
				default:'',
			},
			list:{
				type:Array,
				default:null,
			},
			toFixed:{
				type:[String,Number],
				default:0,
			},
			listWidth:{
				type:Number,
				default:0,
			}
		},
		data() {
			return {
				showList:false,
				// focus:false,
				_focus:false,
				_placeholder:'',
				_value:'',
				_type:'text',
			};
		},
		watch:{
			type:{
				handler(val){
					this._type = val;
					this._placeholder = this.placeholder;
				},
				immediate:true,
			},
			_value(val){
				if((this.type =='number' || this.type == 'numberic') 
				&& val && !isNaN(val)) {
					if(this.toFixed>0){
						let str = val.toString();
						let idx = str.indexOf('.');
						if(idx>=0){
							val = str.substr(0,Number(idx)+Number(this.toFixed)+1);
						}
					}
					
					val = Number(val);
					
					if(val != Math.floor(val)){
						this.$nextTick(()=>{
							this._value = val;
						})	
					}
				}
				
				this.$emit('update:modelValue', val);
				this.$emit('input', val);
			},
			modelValue:{
				handler(val){
					if((this.type =='number' || this.type == 'numberic') 
					&& val && !isNaN(val)) {
						if(this.toFixed>0){
							val = Number(val).toFixed(this.toFixed);
						}
						
						val = Number(val);
					}
					
					this._value = val;
				},
				immediate:true,
			},
		},
		methods:{
			clearInput(){
				this._value='';
				// this.focus = false;
				this.$nextTick(()=>{
					// this.focus = true;
					this.$emit('clearInput');
				});
			},
			onFocus(){
				this._focus		= true;
				this.showList	= true;
			},
			onBlur(e){
				this._focus 	= false;
				this.showList	= false;
				this.$emit('update:focus', false);
				this.$emit('blur' , e);
			},
			passwordShow(){
				this._type = this._type=='text' ? 'password' : 'text';
				// this.focus = false;
				this.$nextTick(()=>{
					// this.focus = true;
					this.showList	= true;
				});
			},
			pressEnter(e){
				// this.focus = false;
				this.$nextTick(()=>{
					// this.focus = true;
					this.showList	= true;
				})
			},
			selectText(text){
				this._value = text;
				
				this.$nextTick(()=>{
					this.$emit('listClick', text);
				})
			}
		}
	}
</script>

<style>
	.dy-input{
		position: relative;
		display:flex;
		min-width:30px;
		height:30px;
		line-height:30px;
		/* padding:0 5px; */
		padding: 0 10px;
		box-sizing: border-box;
		border-radius: 15px;
		background-color: #161619;
		color:#d3d3d3;
		/* border: 1px solid transparent; */
	}
	.dy-input ::selection{
		color:#fff !important;
	}
	.dy-input input{
		height:100%;
		line-height:100%;
		box-sizing: border-box;
		flex:1;
		font-size:14px;
	}
	.dy-input span{
		width: 28px;
		margin-left:4px;
		opacity: 0.5;
		pointer-events: none;
		user-select: none;
		font-size:12px;
		text-align: right;
	}
	.dy-input i{
		margin-left:4px;
		opacity: 0.8;
		cursor: pointer;
		color: #909090;
	}
	.dy-input i:hover{
		opacity: 1.0;
		color: #909090;
	}
	.dy-input i:active{
		opacity: 0.8;
		color: #909090;
	}
	.white{
		background-color: #fff;
		border: 1px solid #fff;
		color: #909090;
	}
	.dy-input.active{
		/* border:1px solid rgb(99, 120, 231) !important; */
	}
	.list{
		position: absolute;
		left: 0;
		top: 28px;
		width: 100%;
		z-index: 99;
		background-color: #fff;
		border: 1px solid #efefef;
		padding: 10px;
		border-radius: 5px;
		box-sizing: border-box;
	}
	.listItem{
		padding:0 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.listItem:hover{
		background-color:#f8f8f8;
		border-radius: 5px;
	}
	.input-icon{
		cursor: auto;
		color: #fff;
	}
</style>